const dateFormat = require('dateformat');
import flatpickr from "flatpickr";

export class DateFilter {
    constructor(selector) {
        this.dateInput = $('.move-in-datepicker');

        // enable / disable filter by dates
        this._filterDates = false;
        if (this.dateInput.lenght) {
            const calendar = flatpickr(this.dateInput[0], {
                altInput: true,
                dateFormat: "Y-m-d",
                altFormat: "F j, Y",
                defaultDate: new Date(),
                static: true
            });
        }

        return this;
    }

    filter(unit) {
        var dateAvailable = unit.data('available-date');

        if (!this.dateInput.lenght || !this._filterDates || this.isSetToToday() || dateAvailable === '') {
            return true;
        }

        //turn date values into time strings to allow for comparison
        dateAvailable = dateAvailable.split("/");
        dateAvailable = new Date(dateAvailable[2], dateAvailable[0] - 1, dateAvailable[1]);
        // dateAvailable = (dateAvailable.getTime() / 1000); //convert to seconds
        // var datepickerDate = parseInt(this.getValue()) + (60*60*24*14); //add two weeks to show future upcoming units'
        var datepickerDate = new Date(this.getValue());
        datepickerDate.setDate(datepickerDate.getDate() + 15);

        return dateAvailable <= datepickerDate;

    }

    isSetToToday() {
        var datepickerDate = new Date(this.getValue());
        var today = dateFormat(new Date(), "yyyy-mm-dd");
        today = new Date(today);

        return today.setHours(0, 0, 0, 0) === datepickerDate.setHours(0, 0, 0, 0);
    }

    getValue() {
        return this.dateInput.val();
    }
};